/**
 * Groups an array of objects by key
 * @param {Array} arr - The source array of objects
 * @param {String} key - The key to group by
 * @example See tests
 * @return {object} The composed object.
 */
const groupByKey = (arr, key) =>
    arr.reduce((groups, value) => {
        if (key in value) {
            if (value[key] in groups) {
                // eslint-disable-next-line no-param-reassign
                groups[value[key]].push(value);
            } else {
                // eslint-disable-next-line no-param-reassign
                groups[value[key]] = [value];
            }
        }
        return groups;
    }, {});

/**
 * Returns a shuffled version of the passed-in array.
 * Pulled from Mango.
 * @param {Array} arr - The array to shuffle.
 * @returns {Array} The shuffled array.
 */
const shuffleArray = (arr) => {
    const filtered = [...arr];

    let current = filtered.length;
    let temp;
    let random;

    while (current !== 0) {
        // pick random element
        random = Math.floor(Math.random() * current);
        current -= 1;

        // swap with currently selected
        temp = filtered[current];
        filtered[current] = filtered[random];
        filtered[random] = temp;
    }

    return filtered;
};

export { groupByKey, shuffleArray };
